import { createReducer } from '@reduxjs/toolkit';

import {
  ActionSuccessType,
  UPDATE_UNREAD_NOTIFICATION_COUNT,
  SHOW_UNREAD_NOTIFICATION_COUNT,
  GET_UNREAD_NOTIFICATION_COUNT,
  FETCH_NEW_NOTIFICATION,
} from 'constants/redux-actions';

const initState = {
  unreadNotificationCount: 0,
  showUnreadNotificationCount: true,
  fetchNewNotification: true,
};

const userNotificationConfigsReducer = createReducer(initState, {
  [UPDATE_UNREAD_NOTIFICATION_COUNT]: (prevState, action) => ({
    ...prevState,
    unreadNotificationCount: action.payload.count,
  }),
  [SHOW_UNREAD_NOTIFICATION_COUNT]: (prevState, action) => ({
    ...prevState,
    showUnreadNotificationCount: action.payload.isShow,
  }),
  [ActionSuccessType(GET_UNREAD_NOTIFICATION_COUNT)]: (prevState, action) => ({
    ...prevState,
    unreadNotificationCount: action.payload.data.unreadCount,
    showUnreadNotificationCount: true,
  }),
  [FETCH_NEW_NOTIFICATION]: (prevState, action) => ({
    ...prevState,
    fetchNewNotification: action.payload.shouldFetch,
  }),
});

export default userNotificationConfigsReducer;
